export default {
  props: {
    val: {
      type: String,
      title: String,
      subtitle: String
    }
  },
  data: function data() {
    return {
      checkedItems: []
    };
  },
  methods: {
    inputChange: function inputChange(checked) {
      this.$emit('input', checked);
    }
  },
  computed: {}
};